import { render } from "./AnswerSurvey.vue?vue&type=template&id=3e6764fa"
import script from "./AnswerSurvey.vue?vue&type=script&lang=js"
export * from "./AnswerSurvey.vue?vue&type=script&lang=js"

import "./AnswerSurvey.vue?vue&type=style&index=0&id=3e6764fa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__